export const ROLES = {
  BROKER: "broker",
  UNDERWRITER: "underwriter",
  ADMIN: "admin",
  SURGEONS: "surgeons", // sure-mc
  HOSPITALS_AND_CLINICS: "hospitals-and-clinics", // sure-mc
};

export default ROLES;
